
//const localApiHost = 'http://api.fitwaps.local:8000/v1'
const localApiHost = 'http://127.0.0.1:8000/v1'
//const localApiHost = 'http://ns380590.ip-188-165-252.eu/v1'
//const localApiHost = 'http://api.fitwaps.local/v1'
//const localApiHost = 'http://127.0.0.1:8000/v1'
const qaApiHost = 'https://api-qa.fitness.org.mx/v1'
const qaCreafitnessApiHost = 'https://api-qa.creafitness.com/v1'
const prodApiHost = 'https://api.creafitness.com/v1'
//const prodApiHost = 'http://ns380590.ip-188-165-252.eu/v1'


let currentHost = window.location.host

let API_BASE = prodApiHost
if (/esreps\.local/.test(currentHost)) {
  API_BASE = localApiHost
} else if (/localhost/.test(currentHost)) {
  API_BASE = localApiHost
} else if (/192.168.1.113/.test(currentHost)) {
  API_BASE = localApiHost
} else if (/35.180.27.72/.test(currentHost)) {
  API_BASE = localApiHost
} else if (/127.0.0.1/.test(currentHost)) {
  API_BASE = localApiHost
} else if (/172.17.*/.test(currentHost)) {
  API_BASE = localApiHost
} else if (/www-qa\.fitness.org.mx/.test(currentHost)) {
  API_BASE = 'https://api-qa.fitness.org.mx/v1'
} else if (/www-qa\.esreps.org/.test(currentHost)) {
  API_BASE = qaCreafitnessApiHost
} else if (/www\.fitness.org.mx/.test(currentHost)) {
  API_BASE = 'https://api.fitness.org.mx/v1'
} else if (/panel\.fedfitness\.org/.test(currentHost)) {
  API_BASE = prodApiHost
} else if (/192.168/.test(currentHost)) {
  API_BASE = localApiHost
} else if (/www.colreps-qa\.esreps/.test(currentHost)) {
  API_BASE = 'https://api-qa-colreps.creafitness.com/v1'
} else if (/www-qa\.esreps/.test(currentHost)) {
  API_BASE = qaApiHost
} else if (/www-qa\.repscolombia/.test(currentHost)) {
  API_BASE = 'http://api-qa-colreps.creafitness.com/v1'
} else if (/www\.repscolombia\.local/.test(currentHost)) {
  API_BASE = localApiHost
} else if (/www\.repscolombia/.test(currentHost)) {
  API_BASE = 'https://api-colreps.creafitness.com/v1'
} else if (/www\.fitnesscolombia/.test(currentHost)) {
  API_BASE = 'https://api-colreps.creafitness.com/v1'
}

// API_BASE = qaCreafitnessApiHost
// API_BASE = prodApiHost

export default API_BASE



// WEBPACK FOOTER //
// ./src/components/services/endpoint_calculator.js